import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Clock, ExternalLink, MapPin, Pencil } from "lucide-react";
import { ReadableNavButton, navActionClass } from "../Sticker";

export default function ClassDashboardHeader({
  schoolSlug,
  className,
  scheduleLabel,
  locationLabel,
  publicPath,
  editPath,
}) {
  return (
    <>
      <div className="max-w-page mx-auto px-4 pt-5 pb-2 flex items-center justify-between gap-2">
        <ReadableNavButton
          as={Link}
          to={schoolSlug ? `/admin/${schoolSlug}` : "/"}
          className={navActionClass}
          data-testid="class-dash-back"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={2.5} aria-hidden />
          Back to School Dashboard
        </ReadableNavButton>
        <div className="flex items-center gap-2 shrink-0">
          {editPath ? (
            <ReadableNavButton
              as={Link}
              to={editPath}
              className={`shrink-0 ${navActionClass} bg-purply border-transparent text-ink hover:bg-plum/20`}
              data-testid="class-dash-edit-details"
              aria-label="Edit class details"
              title="Edit class details"
            >
              <Pencil className="w-4 h-4" strokeWidth={2.5} aria-hidden />
            </ReadableNavButton>
          ) : null}
          {publicPath ? (
            <ReadableNavButton
              as={Link}
              to={publicPath}
              className={`shrink-0 ${navActionClass}`}
              data-testid="class-dash-view-public"
              aria-label="View public page"
              title="View public page"
            >
              <ExternalLink className="w-4 h-4" strokeWidth={2.5} aria-hidden />
            </ReadableNavButton>
          ) : null}
        </div>
      </div>

      <header className="max-w-page mx-auto px-4 mt-3">
        <h1
          className="font-ui font-bold text-[28px] sm:text-[32px] leading-tight text-balance"
          data-testid="class-dash-name"
        >
          {className}
        </h1>
        <p className="mt-2 font-ui font-medium text-[14px] text-ink/70 flex flex-col gap-1.5 sm:flex-row sm:items-center sm:gap-4">
          {scheduleLabel ? (
            <span className="inline-flex items-center gap-1.5">
              <Clock className="w-4 h-4 shrink-0" strokeWidth={2.5} aria-hidden />
              {scheduleLabel}
            </span>
          ) : null}
          {locationLabel ? (
            <span className="inline-flex items-center gap-1.5">
              <MapPin className="w-4 h-4 shrink-0" strokeWidth={2.5} aria-hidden />
              {locationLabel}
            </span>
          ) : null}
        </p>
      </header>
    </>
  );
}
